import React from 'react';
import {IndicatorGraph} from "../../../services/interface/catalogs/serie-graph";
import InfoData from "./InfoData";
import {Person} from "../../../services/interface/query/person";
import {useTranslation} from "react-i18next";
import GraphicMachiningComponent from "../working-information/GraphicMachiningComponent";

interface Props {
    person?: Person;
    indicators?: IndicatorGraph[];
}
const GraphEconomicIncomeValues = ({person, indicators}: Props) => {
    const {t} = useTranslation("global") as { t: (key: string) => string };

    return (
        <div className={'flex flex-col w-full gap-2'}>
            <h3>{t('income-variation')}</h3>
            <div className={'w-full h-full rounded-[5px] !border-[1px] border-secondary flex flex-col gap-1 justify-center'}>
                {indicators &&
                    <div className={'flex flex-row gap-3 py-2 px-2 overflow-x-auto w-full'}>
                        {indicators.map((indicator, index) => (
                            <InfoData key={index} iconName={indicator.icon} value={indicator.value} toolTip={indicator.tooltip}/>
                        ))}
                    </div>
                }
                <GraphicMachiningComponent
                    className={'p-0 -mt-4'}
                    msj={t('income-variation')}
                    {...{person}}
                />
            </div>
        </div>
    );
};

export default GraphEconomicIncomeValues
